import DatabrainLinkIframe from '@home/pages/studio/components/DatabrainLinkIframe';

export default {
  DatabrainLinkIframe,
};
